import { useContext, useState } from "react";
import { Toast } from "@cisco/spaces-dash-lib-notification";
import { Button, Heading, Flex, Modal, MRadio, Text, X } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";
import { selfOnBoarding } from "../../../services/partner-login-service";

interface PartnerUnavailableModalProps {
  isOpen?: boolean;
  closeModal?: () => void;
  licenseAgreedCheck?: () => void;
}

export function PartnerUnavailableModal(props: PartnerUnavailableModalProps): JSX.Element {
  const { isOpen, closeModal, licenseAgreedCheck } = props;
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("PartnerUnavailableModal must be used within an I18nContext.Provider");
  }

  const { t } = i18n;

  const [isInternal, setIsInternal] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const onRadioChange = (e: any) => {
    setIsInternal(e.target?.value === "isInternal");
  };

  const selfOnboardPartner = async () => {
    setIsLoading(true);
    const payload = { isInternal };

    try {
      const res = await selfOnBoarding(payload);
      if (res.status) {
        sessionStorage.setItem("isInternal", String(isInternal));
        setIsLoading(false);
        if (licenseAgreedCheck) licenseAgreedCheck();
        if (closeModal) closeModal();
      }
    } catch (error) {
      console.error(error);
      Toast.show(t("auth.login.login-partner-base.error-occurred-contact-support", { ns: "spaces-dash-app-partners-login" }), "", { status: "negative" });
      if (closeModal) closeModal();
    }
  };

  return (
    <Modal isOpen={isOpen} size="xl">
      <Flex justify="flex-end" style={{ marginBottom: "16px" }}>
        <X size={16} weight="bold" onClick={closeModal} style={{ cursor: "pointer" }} />
      </Flex>
      <Flex direction="vertical" align="center">
        <Heading size="primary">
          {t("auth.login.login-partner-base.welcome-text", { ns: "spaces-dash-app-partners-login" })} {sessionStorage.getItem("customerName") ?? ""}
        </Heading>
        <Text size="p2">{t("auth.login.login-partner-base.to-cisco-spaces", { ns: "spaces-dash-app-partners-login" })}</Text>
        <Text style={{ marginTop: "16px" }}>{t("auth.login.login-partner-base.one-step-away-to-complete-partner-account", { ns: "spaces-dash-app-partners-login" })}</Text>
        <Flex direction="vertical" gap={16} style={{ marginTop: "16px", padding: "32px" }}>
          <MRadio
            direction="vertical"
            legend={`${t("auth.login.login-partner-base.whom-are-you-creating-text", { ns: "spaces-dash-app-partners-login" })}?`}
            onChange={onRadioChange}
            options={[
              {
                key: `${t("auth.login.login-partner-base.create-apps-for-organization")} (${t("auth.login.login-partner-base.internal-text", { ns: "spaces-dash-app-partners-login" })})`,
                label: `${t("auth.login.login-partner-base.create-apps-for-organization", { ns: "spaces-dash-app-partners-login" })} (${t("auth.login.login-partner-base.internal-text", { ns: "spaces-dash-app-partners-login" })})`,
                value: "isInternal"
              },
              {
                key: t("auth.login.login-partner-base.developer-provides-solution-text", { ns: "spaces-dash-app-partners-login" }),
                label: t("auth.login.login-partner-base.developer-provides-solution-text", { ns: "spaces-dash-app-partners-login" }),
                value: "notInternal"
              }
            ]}
            size="md"
            value={isInternal ? "isInternal" : "notInternal"}
          />
          <Button style={{ width: "fit-content", padding: "8px 24px" }} onClick={selfOnboardPartner} disabled={isLoading}>
            {t("auth.login.login-partner-base.continue-text", { ns: "spaces-dash-app-partners-login" })}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
